var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Edit",
  fill: "#3A414C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20,18.2999784 L20,21 L4,21 L4,18.2999784 L20,18.2999784 Z M17.3875556,7.55479244 L14.6133333,4.74586997 L16.3376356,3 L19.1118578,5.80892247 L17.3875556,7.55479244 Z M10.3292444,14.6999496 L7.55555556,14.6999496 L7.55555556,11.8910271 L13.7242667,5.64587717 L16.4984889,8.45479964 L10.3292444,14.6999496 Z",
  id: "Fill-1"
})))));
export { SvgEdit as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.2277ec98.svg";